import { useSelector } from 'react-redux';
import { DashboardEstimate, EstimatesStatus } from '../../../../types/dashboardInformation';
import { useEffect, useState } from 'react';

export const useInProgressEstimates = () => {
    //@ts-ignore
    const { estimates, is_customer } = useSelector((state) => state.dashboardReducer);
    const [inProgressEstimates, setInProgressEstimates] = useState(
        estimates.estimates.filter(
            (estimate: DashboardEstimate) =>
                estimate.status === EstimatesStatus.IN_EXPLOITATIONS ||
                estimate.status === EstimatesStatus.COMPLETED
        )
    );

    useEffect(() => {
        setInProgressEstimates(
            estimates.estimates.filter(
                (estimate: DashboardEstimate) =>
                    estimate.status === EstimatesStatus.IN_EXPLOITATIONS ||
                    estimate.status === EstimatesStatus.COMPLETED
            )
        );
    }, [estimates.estimates]);

    return { estimates, inProgressEstimates, is_customer };
};
